export enum LanguageCode {
  "ar" = "ar",
  "en" = "en",
  "es" = "es",
  "fr" = "fr",
}
